<template>
  <div class="sidebar-container p-2">

    <div class="row">
      <div class="col-12">
        <h6 class="mb-2"><strong>{{ headingText }}</strong></h6>
        <template v-if="typesenseResponse && hits.length > 0">

          <ExploreV2TrailCard v-for="hit in hits" :hit="hit" :source="searchSource" :key="hit.document.id" />

          <button class="btn btn-primary btn-block" @click="renderTrailCount += perPage" v-if="moreAvailable">Load more</button>
          <div class="d-block" style="height: 500px;"></div>

        </template>
        <template v-else>
          <div class="card mb-3">
            <div class="p-2">
              <p class="m-0"><strong>{{ emptyText }}</strong></p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import ExploreV2TrailCard from './ExploreV2TrailCard.vue';

export default {
  components: {
    ExploreV2TrailCard,
  },
  data() {
    return {
      perPage: 5,
      renderTrailCount: 5,
    };
  },
  computed: {
    searchSource() {
      return this.$store.state.exploreV2.searchSource || 'hikes';
    },
    isCommunitySource() {
      return this.searchSource === 'community';
    },
    headingText() {
      return this.isCommunitySource ? 'Community in this area' : 'Popular Hikes in this area';
    },
    emptyText() {
      return this.isCommunitySource
        ? 'No community activity in this area'
        : 'No trails in this area';
    },
    hits() {
      if (!this.typesenseResponse?.hits?.length) {
        return [];
      }
      const trailCount = this.typesenseResponse.hits.length > this.renderTrailCount ? this.renderTrailCount : this.typesenseResponse.hits.length;
      return this.typesenseResponse.hits.slice(0, trailCount);
    },
    moreAvailable() {
      return (this.typesenseResponse?.hits?.length || 0) > this.renderTrailCount;
    },
    searchQuery: {
      get() {
        return this.$store.state.exploreV2.searchString;
      },
      set(value) {
        this.$store.commit('exploreV2/setSearchString', value);
      },
    },
    typesenseResponse() {
      return this.$store.state.exploreV2.typesenseResponse;
    },
  },
};
</script>
